import * as actions from './email-config.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { EmailUserConfigModel } from '@smarttask-common/src/lib/models/Integrations/Email/Config/EmailUserConfigModel';

export const configAdapter = createEntityAdapter<EmailUserConfigModel>({
    selectId: (x) => x.config_id,
});
export interface EmailUserConfigState extends EntityState<EmailUserConfigModel> {
    selected_config_id: number;
}

export const initialState: EmailUserConfigState = configAdapter.getInitialState({
    selected_config_id: undefined,
});

export function EmailUserConfigReducers(state: EmailUserConfigState = initialState, action: actions.EmailUserConfigActions) {
    switch (action.type) {
        case actions.EmailUserConfigActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_config_id: action.selected_config_id };
            //console.log(state);
            return state;

        case actions.EmailUserConfigActionTypes.ADD_EMAIL_USER_CONFIG:
            return configAdapter.addOne(action.config, state);

        case actions.EmailUserConfigActionTypes.ADD_EMAIL_USER_CONFIGS:
            return configAdapter.addMany(action.configs, state);

        case actions.EmailUserConfigActionTypes.UPSERT_EMAIL_USER_CONFIG:
            return configAdapter.upsertOne(action.config, state);

        case actions.EmailUserConfigActionTypes.UPSERT_EMAIL_USER_CONFIGS:
            return configAdapter.upsertMany(action.configs, state);

        case actions.EmailUserConfigActionTypes.UPDATE_EMAIL_USER_CONFIG:
            return configAdapter.updateOne(action.config, state);

        case actions.EmailUserConfigActionTypes.UPDATE_EMAIL_USER_CONFIGS:
            return configAdapter.updateMany(action.configs, state);

        case actions.EmailUserConfigActionTypes.DELETE_EMAIL_USER_CONFIG:
            return configAdapter.removeOne(action.config_id, state);

        case actions.EmailUserConfigActionTypes.DELETE_EMAIL_USER_CONFIGS:
            return configAdapter.removeMany(action.config_ids, state);

        case actions.EmailUserConfigActionTypes.DELETE_ALL_EMAIL_USER_CONFIGS:
            return configAdapter.removeMany(action.config_ids, state);

        case actions.EmailUserConfigActionTypes.DELETE_ALL:
            return configAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getEmailUserConfigState = createFeatureSelector<EmailUserConfigState>('emailUserConfig');

export const { selectIds, selectEntities, selectAll, selectTotal } = configAdapter.getSelectors(getEmailUserConfigState);

const getSelectedConfigIdState = (state: EmailUserConfigState) => {
    return state.selected_config_id;
};
export const getSelectedConfigId = createSelector(getEmailUserConfigState, getSelectedConfigIdState);

export const getSelectedConfig = createSelector(getEmailUserConfigState, (state: EmailUserConfigState) => {
    if (state.selected_config_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_config_id];
});
